// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

class Pagination extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      window: props.window || 3
    }
  }

  currentPage = () => this.props.currentPage
  totalPages = () => this.props.totalPages

  isFirstPage = () => {
    return this.currentPage() === 1
  }

  isLastPage = () => {
    return this.currentPage() === this.totalPages()
  }

  previousPage = () => {
    return (
      <li className={`previous-page ${this.isFirstPage() ? 'disabled' : ''}`}>
        <a
          rel='prev'
          onClick={(e) =>
            this.isFirstPage() ? e.preventDefault() : this.props.executeSearch(this.currentPage() - 1)}
        >
          <i className='far fa-angle-left' />
        </a>
      </li>
    )
  }

  ellipsis = () => {
    if (this.totalPages() > this.currentPage() + this.state.window) {
      return (
        <li className='ellipsis'>
          <a onClick={(e) => e.preventDefault()}>…</a>
        </li>
      )
    }
  }

  nextPage = () => {
    return (
      <li className={`next-page ${this.isLastPage() ? 'disabled' : ''}`}>
        <a
          rel='next'
          onClick={(e) =>
            this.isLastPage() ? e.preventDefault() : this.props.executeSearch(this.currentPage() + 1)}
        >
          <i className='far fa-angle-right' />
        </a>
      </li>
    )
  }

  numberedPages = () => {
    let pageStart = this.currentPage() - this.state.window
    if (pageStart < 1) {
      pageStart = 1
    }
    let pageEnd = this.currentPage() + this.state.window
    if (pageEnd > this.totalPages()) {
      pageEnd = this.totalPages()
    }

    const pages = []
    for (let page = pageStart; page < pageEnd + 1; page++) {
      pages.push(
        <li key={page} className={page === this.currentPage() ? 'current' : ''}>
          <a
            onClick={() => this.props.executeSearch(page)}
          >
            {page}
          </a>
        </li>
      )
    }

    return (<>{pages}</>)
  }

  render () {
    if (this.totalPages() > 1) {
      return (
        <div className='grid-x' id='pagination-container'>
          <div className='cell text-center'>
            <div className='pagination-centered2'>
              <ul className='paginatio2'>
                {this.previousPage()}
                {this.numberedPages()}
                {this.ellipsis()}
                {this.nextPage()}
              </ul>
            </div>
          </div>
        </div>
      )
    } else {
      return (<></>)
    }
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired
}

export default Pagination
